import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import { IconUpload } from "@tabler/icons-react";
import { API_URL } from "utils/constants";

const MasterDataFormV2 = ({
  // title,
  apiUrl,
  initialData,
  fields = [],
  onSuccess,
  onError,
}) => {
  const isUpdateMode = initialData && initialData.id;

  // 🔹 **Inisialisasi formData dengan initialData saat mode edit**
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Validation function
  const validateField = (name, value) => {
    const field = fields.find((f) => f.name === name);
    if (!field) return "";

    if (
      field.required &&
      (!value || value === "" || (Array.isArray(value) && value.length === 0))
    ) {
      return `${field.label} is required`;
    }

    if (field.type === "email" && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return "Please enter a valid email address";
      }
    }

    if (field.minLength && value && value.length < field.minLength) {
      return `${field.label} must be at least ${field.minLength} characters`;
    }

    if (field.maxLength && value && value.length > field.maxLength) {
      return `${field.label} must not exceed ${field.maxLength} characters`;
    }

    return "";
  };

  const validateForm = () => {
    const newErrors = {};
    fields.forEach((field) => {
      const error = validateField(field.name, formData[field.name]);
      if (error) {
        newErrors[field.name] = error;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // useEffect(() => {
  //   if (isUpdateMode) {
  //     setFormData(initialData);
  //   } else {
  //     const defaultValues = {};
  //     fields.forEach((field) => {
  //       defaultValues[field.name] = field.type === "checkbox" ? false : "";
  //     });
  //     setFormData(defaultValues);
  //   }
  // }, [initialData, fields, isUpdateMode]);

  useEffect(() => {
    const defaultValues = {};
    fields.forEach((field) => {
      if (field.type === "checkbox") {
        defaultValues[field.name] = false;
      } else if (field.type === "multiselect") {
        defaultValues[field.name] = [];
      } else {
        defaultValues[field.name] = "";
      }
    });

    const prefill = { ...defaultValues };

    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        const field = fields.find((f) => f.name === key);
        if (key === "is_active") {
          prefill[key] = Boolean(initialData[key]);
        } else if (field && field.type === "date" && initialData[key]) {
          // Convert date string to Date object for DatePicker
          prefill[key] = new Date(initialData[key]);
        } else {
          prefill[key] = initialData[key];
        }
      });

      // ❗️Override khusus untuk category_ids
      if (
        (!initialData.category_ids || initialData.category_ids.length === 0) &&
        Array.isArray(initialData.categories)
      ) {
        prefill["category_ids"] = initialData.categories.map((cat) => cat.id);
      }
    }

    setFormData(prefill);
  }, [initialData, fields]);

  // const [selectedFile, setSelectedFile] = useState(null);

  // const { createData, loading: creating } = useCreateData(apiUrl);
  // const { updateData, loading: updating } = useUpdateData(
  //   `${apiUrl}/${initialData?.id}`
  // );

  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(
    initialData?.image_url || ""
  ); // ✅ Simpan gambar lama

  const formatNumber = (value) => {
    const number = value.replace(/\D/g, "");
    return new Intl.NumberFormat("id-ID").format(Number(number));
  };

  const unformatNumber = (value) => {
    return value.replace(/\./g, "");
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    // Clear error when field is touched
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // 🔹 Untuk field price atau min_price
    if (["price", "min_price"].includes(name)) {
      const formatted = formatNumber(value); // untuk tampil
      const raw = unformatNumber(formatted); // untuk dikirim
      setFormData((prev) => ({
        ...prev,
        [name]: raw,
        [`${name}_display`]: formatted, // ← simpan tampilan terformat
      }));
      return;
    }

    // 🔹 Field lain
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (type === "file") {
      const file = files[0];
      if (file) {
        setSelectedFile(file);
        setImagePreview(URL.createObjectURL(file));
      }
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    const error = validateField(name, formData[name]);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  // const handleChangeV3 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file); // ✅ Simpan file baru
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview
  //     }
  //   }
  // };

  // const handleChangeV2 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));

  //   if (type === "file") {
  //     const file = files[0];

  //     if (file) {
  //       setSelectedFile(file);
  //       setImagePreview(URL.createObjectURL(file)); // ✅ Tampilkan preview file baru
  //     }
  //   }
  // };

  // const handleChangeV1 = (e) => {
  //   const { name, value, type, checked, files } = e.target;

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]:
  //       type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //   }));

  //   if (type === "file") {
  //     setSelectedFile(files[0]?.name || "");
  //   }
  // };

  const handleSelectChange = (selectedOption, field) => {
    // Clear error when field is changed
    if (errors[field.name]) {
      setErrors((prev) => ({
        ...prev,
        [field.name]: "",
      }));
    }

    if (field.loadOptions) {
      // For async select, store the object
      setFormData((prev) => ({
        ...prev,
        [field.name]: selectedOption,
      }));
    } else {
      // For regular select, store the value
      setFormData((prev) => ({
        ...prev,
        [field.name]: selectedOption ? selectedOption.value : "",
      }));
    }
  };

  const handleDateChange = (date, field) => {
    // Clear error when field is changed
    if (errors[field.name]) {
      setErrors((prev) => ({
        ...prev,
        [field.name]: "",
      }));
    }

    setFormData((prev) => ({
      ...prev,
      [field.name]: date,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form before submitting
    if (!validateForm()) {
      // Mark all required fields as touched to show errors
      const newTouched = {};
      fields.forEach((field) => {
        if (field.required) {
          newTouched[field.name] = true;
        }
      });
      setTouched((prev) => ({ ...prev, ...newTouched }));
      return;
    }

    try {
      const submitData = new FormData();

      // 🔹 Tambahkan semua field kecuali `image` jika tidak ada file baru
      // Object.keys(formData).forEach((key) => {
      //   if (
      //     formData[key] !== null &&
      //     formData[key] !== undefined &&
      //     key !== "image_url" // ✅ Jangan kirim `image_url`
      //   ) {
      //     if (
      //       formData.recorded_at &&
      //       typeof formData.recorded_at === "string" &&
      //       formData.recorded_at.includes("T")
      //     ) {
      //       const [date, time] = formData.recorded_at.split("T");
      //       formData.recorded_at = `${date} ${time}:00`; // ✅ format: 2025-03-31 13:13:00
      //     }

      //     submitData.append(key, formData[key]);
      //   }
      // });

      Object.keys(formData).forEach((key) => {
        const value = formData[key];

        // khusus array seperti category_ids[]
        if (Array.isArray(value)) {
          value.forEach((val, idx) => {
            submitData.append(`${key}[${idx}]`, val);
          });
        } else if (
          value !== null &&
          value !== undefined &&
          key !== "image_url"
        ) {
          // khusus untuk datetime field
          if (
            key === "recorded_at" &&
            typeof value === "string" &&
            value.includes("T")
          ) {
            const [date, time] = value.split("T");
            submitData.append(key, `${date} ${time}:00`);
          } else if (value instanceof Date) {
            // khusus untuk date field (start_date, end_date, dll) - format dalam timezone lokal
            const year = value.getFullYear();
            const month = String(value.getMonth() + 1).padStart(2, "0");
            const day = String(value.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD dalam timezone lokal
            submitData.append(key, formattedDate);
          } else if (
            typeof value === "object" &&
            value !== null &&
            value.value !== undefined
          ) {
            // For async select objects
            submitData.append(key, value.value);
          } else if (key === "is_active") {
            // Convert boolean to 1 or 0
            submitData.append(key, value ? 1 : 0);
          } else {
            submitData.append(key, value);
          }
        }
      });

      // 🔹 Jika ada field file, handle file upload
      const hasFileFields = fields.some((field) => field.type === "file");
      if (hasFileFields) {
        if (selectedFile) {
          submitData.append("image", selectedFile);
        } else {
          // 🔥 Hapus `image` dari FormData jika tidak ada file baru
          submitData.delete("image");
        }
      }

      // 🔹 Jika update, tambahkan `_method: "PUT"`
      if (isUpdateMode) {
        submitData.append("_method", "PUT");
      }

      const token = localStorage.getItem("token"); // 🔥 Ambil token untuk autentikasi
      const url = isUpdateMode
        ? `${API_URL}${apiUrl}/${initialData?.id}`
        : `${API_URL}${apiUrl}`;

      const response = await fetch(url, {
        method: "POST", // Gunakan POST karena ada `_method: PUT`
        body: submitData,
        headers: {
          Authorization: `Bearer ${token}`, // 🔥 Tambahkan token di sini
        },
      });

      const result = await response.json();

      if (response.ok) {
        onSuccess(result);
      } else {
        onError(result);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="d-flex flex-column">
      <div className="action-sheet-content flex-grow-1">
        {fields.map((field) => (
          <div className="row mb-3 align-items-center" key={field.name}>
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              {field.label}:
            </label>
            <div className="col-sm-8">
              {["text", "number", "password", "email", "tel"].includes(
                field.type
              ) && (
                // <input
                //   type={field.type}
                //   className={clsx("form-control")}
                //   name={field.name}
                //   value={formData[field.name] || ""}
                //   onChange={handleChange}
                // />
                <input
                  type={field.type}
                  className={clsx("form-control", {
                    "is-invalid": errors[field.name] && touched[field.name],
                  })}
                  name={field.name}
                  value={
                    ["price", "min_price"].includes(field.name)
                      ? formData[`${field.name}_display`] || ""
                      : formData[field.name] || ""
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={field.placeholder}
                  required={field.required}
                />
              )}

              {field.type === "textarea" && (
                <textarea
                  className={clsx("form-control", {
                    "is-invalid": errors[field.name] && touched[field.name],
                  })}
                  name={field.name}
                  rows={field.rows || 3}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder={field.placeholder}
                  required={field.required}
                />
              )}

              {field.type === "select" &&
                (field.onInputChange || field.loadOptions ? (
                  <AsyncSelect
                    loadOptions={field.loadOptions}
                    onInputChange={field.onInputChange}
                    value={
                      field.value ||
                      (field.loadOptions
                        ? formData[field.name]
                        : field.options?.find(
                            (opt) => opt.value === formData[field.name]
                          ) || "")
                    }
                    onChange={
                      field.onChange ||
                      ((selected) => handleSelectChange(selected, field))
                    }
                    isSearchable
                    placeholder={field.placeholder || `Pilih ${field.label}`}
                    isLoading={field.isLoading}
                    defaultOptions={field.defaultOptions || field.options}
                    cacheOptions={false}
                    className={
                      errors[field.name] && touched[field.name]
                        ? "is-invalid"
                        : ""
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor:
                          errors[field.name] && touched[field.name]
                            ? "#dc3545"
                            : base.borderColor,
                      }),
                    }}
                  />
                ) : (
                  <Select
                    options={field.options}
                    value={
                      field.options?.find(
                        (opt) => opt.value === formData[field.name]
                      ) || ""
                    }
                    onChange={(selected) => handleSelectChange(selected, field)}
                    isSearchable
                    placeholder={field.placeholder || `Pilih ${field.label}`}
                    className={
                      errors[field.name] && touched[field.name]
                        ? "is-invalid"
                        : ""
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor:
                          errors[field.name] && touched[field.name]
                            ? "#dc3545"
                            : base.borderColor,
                      }),
                    }}
                  />
                ))}

              {/* {field.type === "multiselect" && (
                <Select
                  options={field.options}
                  isMulti
                  closeMenuOnSelect={false}
                  value={field.options.filter((opt) =>
                    (formData[field.name] || []).includes(opt.value)
                  )}
                  onChange={(selected) => {
                    const selectedValues = selected.map((item) => item.value);
                    setFormData((prev) => ({
                      ...prev,
                      [field.name]: selectedValues,
                    }));
                  }}
                  placeholder={`Select ${field.label}`}
                />
              )} */}

              {field.type === "multiselect" &&
                (field.onInputChange || field.loadOptions ? (
                  <AsyncSelect
                    loadOptions={field.loadOptions}
                    onInputChange={field.onInputChange}
                    isMulti
                    closeMenuOnSelect={false}
                    value={
                      field.value ||
                      field.options?.filter((opt) =>
                        (formData[field.name] || []).includes(opt.value)
                      )
                    }
                    onChange={
                      field.onChange ||
                      ((selected) => {
                        const selectedValues = selected.map(
                          (item) => item.value
                        );
                        setFormData((prev) => ({
                          ...prev,
                          [field.name]: selectedValues,
                        }));
                      })
                    }
                    placeholder={field.placeholder || `Select ${field.label}`}
                    isLoading={field.isLoading}
                    defaultOptions={field.defaultOptions || field.options}
                    cacheOptions={false}
                    className={
                      errors[field.name] && touched[field.name]
                        ? "is-invalid"
                        : ""
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor:
                          errors[field.name] && touched[field.name]
                            ? "#dc3545"
                            : base.borderColor,
                      }),
                    }}
                  />
                ) : (
                  <Select
                    options={field.options}
                    isMulti
                    closeMenuOnSelect={false}
                    value={field.options?.filter((opt) =>
                      (formData[field.name] || []).includes(opt.value)
                    )}
                    onChange={(selected) => {
                      const selectedValues = selected.map((item) => item.value);
                      setFormData((prev) => ({
                        ...prev,
                        [field.name]: selectedValues,
                      }));
                    }}
                    placeholder={field.placeholder || `Select ${field.label}`}
                    className={
                      errors[field.name] && touched[field.name]
                        ? "is-invalid"
                        : ""
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor:
                          errors[field.name] && touched[field.name]
                            ? "#dc3545"
                            : base.borderColor,
                      }),
                    }}
                  />
                ))}

              {/* {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))} */}
              {field.type === "radio" &&
                field.options?.map((option) => (
                  <div
                    className="form-check form-check-inline"
                    key={option.value}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name={field.name}
                      value={option.value}
                      checked={formData[field.name] === option.value}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">{option.label}</label>
                  </div>
                ))}

              {field.type === "checkbox" && (
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name={field.name}
                    checked={formData[field.name] || false}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">{field.label}</label>
                </div>
              )}

              {field.type === "date" && (
                <DatePicker
                  selected={formData[field.name]}
                  onChange={(date) => handleDateChange(date, field)}
                  className={clsx("form-control", {
                    "is-invalid": errors[field.name] && touched[field.name],
                  })}
                  dateFormat="yyyy-MM-dd"
                  placeholderText={field.placeholder}
                />
              )}

              {field.type === "file" && (
                <div className="input-group">
                  <input
                    type="file"
                    className={clsx("form-control", {
                      "is-invalid": errors[field.name] && touched[field.name],
                    })}
                    name={field.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={field.required}
                  />
                  <span className="input-group-text">
                    <IconUpload size={18} />
                  </span>
                </div>
              )}

              {field.type === "datetime-local" && (
                <input
                  type="datetime-local"
                  className={clsx("form-control", {
                    "is-invalid": errors[field.name] && touched[field.name],
                  })}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required={field.required}
                />
              )}

              {field.type === "color" && (
                <input
                  type="color"
                  className={clsx("form-control form-control-color", {
                    "is-invalid": errors[field.name] && touched[field.name],
                  })}
                  name={field.name}
                  value={formData[field.name] || "#000000"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  title="Choose your color"
                  required={field.required}
                />
              )}

              {/* {selectedFile && (
                <p className="mt-1 text-muted">File: {selectedFile}</p>
              )} */}
            </div>
            {errors[field.name] && touched[field.name] && (
              <div className="col-sm-8 offset-sm-4">
                <div className="text-danger small mt-1">
                  {errors[field.name]}
                </div>
              </div>
            )}
          </div>
        ))}

        {imagePreview && (
          <div className="row mb-3 align-items-center">
            <label className="col-sm-4 col-form-label d-flex justify-content-end">
              Image Preview:
            </label>
            <div className="col-sm-8">
              <img
                src={imagePreview}
                alt="Preview"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        )}
      </div>
      {/* print json */}
      {/* <div className="row mb-3 align-items-center">
        <label className="col-sm-4 col-form-label d-flex justify-content-end">
          JSON:
        </label>
        <div className="col-sm-8">
          <pre>{JSON.stringify(formData, null, 2)}</pre>
        </div>
      </div> */}
      <div className="form-group mt-auto d-grid">
        <button type="submit" className="btn btn-primary btn-block">
          {isUpdateMode ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default MasterDataFormV2;
